module.exports = __webpack_public_path__ + "static/media/kakis3.403d7423.png";